import axios from "axios";
import Api from "@/services/Api";
import { persistSession, clearSession, loadSession } from "./session";

export function installTokenBridge(router) {
  let systemToken = null;
  const session = loadSession();

  if (session && session["x-access-token"]) {
    systemToken = session["x-access-token"];
  } else {
    try {
      systemToken = localStorage.getItem("x-access-token");
    } catch (error) {
      systemToken = null;
    }
  }

  if (systemToken) {
    axios.defaults.headers.common["x-access-token"] = systemToken;
  }

  router.getSystemToken = function () {
    return systemToken;
  };

  return {
    getToken() {
      return systemToken;
    },
    setToken(token) {
      systemToken = token;
    },
    bootSession: session && session["x-access-token"] ? session : null,
  };
}

export function rootMixin(bridge) {
  const host = typeof window !== "undefined" ? window.location.host : "";
  const urlParts = host ? host.split(".") : [];

  return {
    data() {
      return {
        accessToken: "",
        account: null,
        domainLength: urlParts.length,
        host,
        integration: null,
        tenantName: "",
        token: null,
        urlParts,
        user: null,
      };
    },
    created() {
      if (bridge.bootSession) {
        this.integrationLogin(bridge.bootSession);
      }
    },
    methods: {
      subDomain() {
        const host = this.host ? String(this.host).split(":")[0] : "";
        if (/^\d{1,3}(\.\d{1,3}){3}$/.test(host) || host === "localhost" || host.endsWith(".localhost")) {
          return "";
        }
        if (this.urlParts.length > 2 && this.urlParts[0] !== "www") {
          return this.urlParts[0];
        }
        return "";
      },
      hasFeature(feature) {
        const features = this.integration && this.integration.layout && this.integration.layout.features;
        return Array.isArray(features) && features.indexOf(feature) >= 0;
      },
      isLoggedIn() {
        return bridge.getToken() !== null && !!this.account;
      },
      logout() {
        this.setToken(null);
        this.account = null;
        this.integration = null;
        clearSession();
      },
      setToken(token) {
        this.accessToken = token;
        bridge.setToken(token);
        axios.defaults.headers.common["x-access-token"] = token;

        try {
          if (token == null) {
            localStorage.removeItem("x-access-token");
          } else {
            localStorage.setItem("x-access-token", token);
          }
        } catch (error) {
          // iframe / blocked storage
        }
      },
      getToken() {
        return bridge.getToken();
      },
      async login() {},
      async integrationLogin(data) {
        if (!data) {
          return;
        }
        persistSession(data);
        this.setToken(data["x-access-token"]);
        this.account = data.account;
        const rest = Object.assign({}, data);
        delete rest.account;
        delete rest["x-access-token"];
        this.integration = rest;
      },
      clearGlobals() {
        this.user = {};
        this.authenticated = false;
        Api.token = "";
        this.logout();
        this.tenantName = "";
        try {
          sessionStorage.clear();
        } catch (error) {
          // iframe / blocked storage
        }
      },
      async confirmYesNo(title, icon = "question", cancelButtonText = "No", confirmButtonText = "Yes") {
        const result = await this.$swal({
          icon,
          title,
          showCancelButton: true,
          cancelButtonText,
          confirmButtonText,
          allowEscapeKey: true,
          allowEnterKey: true,
        });
        return !result.dismiss;
      },
      async confirm(title, icon = "question") {
        const result = await this.$swal({
          icon,
          title,
          showCancelButton: true,
          allowEscapeKey: true,
        });
        return !result.dismiss;
      },
      async alert(title, icon = "success") {
        await this.$swal({
          icon,
          title,
          allowEscapeKey: true,
        });
      },
    },
  };
}
